module.exports = "/legacy/d4a832c4741268b5636f23f517ca9be3.svg";